export const tokenParameter = 'token';
export const emailAddressParameter = 'email';
export const passwordMinimalLength = 4;
